import React from "react";
import '../style/calendar.css'

import fakestuff from '../assets/Schedule.png'
const Calendar = () =>{
    return(

        <img src={fakestuff} alt="Working Calendar"></img>

    )
}

export default Calendar